import { ScheduleConfigService } from '@/openapi';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '@/util/queryKeys';

export const useVacationRequestDeleteMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (requestId: number) => {
      return ScheduleConfigService.scheduleConfigServiceDeleteVacationRequest({
        path: { requestId },
      });
    },
    onSettled: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: queryKeys.schedule.vacationRequests(),
        }),
        queryClient.invalidateQueries({ queryKey: queryKeys.schedule.all }),
      ]);
    },
  });
};
